import {
  DollarCircleOutlined,
  FileTextOutlined,
  SendOutlined,
  ShoppingCartOutlined,
  SmileOutlined,
  SyncOutlined,
  CheckCircleOutlined,
} from "@ant-design/icons";

export const paymentSteps = [
  {
    title: "Record Customer Payments",
    description:
      "Manually record customer payments against sales invoices and track pending amounts.",
    icon: SmileOutlined,
    bg: "#e6f7ff",
    color: "#1890ff",
  },
  {
    title: "Partial and Full Payment Handling",
    description:
      "Easily manage advance payments, part payments, and final settlements.",
    icon: FileTextOutlined,
    bg: "#f6ffed",
    color: "#52c41a",
  },
  {
    title: "Outstanding Receivables Summary",
    description:
      " Instantly view customer-wise and invoice-wise pending balances.",
    icon: ShoppingCartOutlined,
    bg: "#e6f7ff",
    color: "#1890ff",
  },
  {
    title: "Record Supplier Payments",
    description: "Record payments made to suppliers against purchase invoices.",
    icon: SendOutlined,
    bg: "#f9f0ff",
    color: "#722ed1",
  },
  {
    title: "Partial and Full Payment Handling",
    description: "Manage staggered payments and final settlements.",
    icon: CheckCircleOutlined,
    bg: "#fff7e6",
    color: "#fa8c16",
  },
  {
    title: "Outstanding Payables Summary",
    description: " Keep track of supplier dues and avoid overdue payments.",
    icon: DollarCircleOutlined,
    bg: "#fff1f0",
    color: "#f5222d",
  },
];

export enum paymentFeatureText {
  HERO_TITLE = "Payment Management Made Simple",
 HERO_DESCRIPTION = `Seamlessly Track, Record, and Manage All Your Payables and Receivables.\n\nWelcome to the Payment Management Module of Ease Margin - your all-in-one solution to record payments, track outstanding balances, and manage accounts across your entire sales and purchase cycles. Get complete financial visibility and control without the need for a payment gateway.`,

  HERO_BUTTON = "Get Started for Free",

  INTRO_TITLE = "💼 Why Struggle with Manual Payment Tracking? Go Smart with Ease Margin.",
  INTRO_DESCRIPTION = `No more chasing payments, no more missing dues.With Ease Margin, your entire payment process is integrated, manual, and fully traceable. `,

  SALES_FLOW_TITLE = "🔁 Visualize and Control Every payment Step",
  MULTI_FORMAT_TITLE = "🗂️ Multi-Format Payment Records: Your payment records your way.",
  DASHBOARD_TITLE = "📊 Real-Time Payment Dashboard",
  ADVANTAGE_TITLE = "⚙️ Why Choose Ease Margin for Payment Management?",
  DOC_FORMAT = "📝 Supported Payment Modes:",
  SHARING_STORE = "☁️ Seamless Sharing & Storage",

  PERFECT_FOR_TITLE = "🏢 Perfect For:",
  CTA_TITLE = "🚀 Start Using Smart Payment Management Today.",

  CTA_DESCRIPTION = `Transform your payment tracking into a smooth, transparent, and fully controlled process with Ease Margin.`,
  CTA_BUTTON = "Contact Us for a Free Demo",
}

export const paymentTemplates = [
  {
    icon: "🧾",
    title: "Customizable Payment Vouchers",
    description:
      "Add your company logo, payment terms, and custom notes (excluding bank details).",
  },
  {
    icon: "📁",
    title: "Smart Payment Repository",
    description:
      "Search and filter by customer, supplier, date, payment mode, and document type",
  },
];

export const paymentFeaturedCards = [
  {
    icon: "✨",
    title: "Additional Smart Features",
    description:
      "Take your payment management to the next level with these advanced capabilities:",
  },
  {
    icon: "🔗",
    title: "Auto-Linked Payments:",
    description:
      "Payments automatically linked to sales and purchase documents for easy tracking.",
  },
  {
    icon: "📦",
    title: "Bulk Payment Recording for Suppliers:",
    description:
      "Batch record payments to multiple suppliers at once, saving time and effort.",
  },
  {
    icon: "🚫",
    title: "Payment Due Alerts and Smart Reminders:",
    description:
      "Proactive notifications for pending payments, overdue amounts, and upcoming dues.",
  },
  {
    icon: "⏰",
    title: "Payment Mode and Account-Wise Reporting:",
    description:
      "Detailed reports on payments made by mode (cash, cheque, bank transfer) and account for better financial tracking.",
  },
  {
    icon: "✅",
    title: "Approval Workflow Integration:",
    description:
      "Built-in approval stages for payment requests and orders for tighter control.",
  },
  {
    icon: "📊",
    title: "Real-Time Outstanding and Balance Summaries:",
    description:
      "Instantly view customer-wise and supplier-wise outstanding balances, payment history, and due amounts.",
  },
];

export const paymentDashboardFeatures = [
  "Customer-wise Receivables Overview",
  "Supplier-wise Payables Overview",
  "Pending Payment Alerts",
  "Advance Payment and Overdue Summaries",
  "Smart Notifications for Upcoming Dues",
];

export const paymentAdvantages = [
  "Integrated Receivable and Payable Tracking",
  "Multi-Format Manual Payment Support",
  "Real-Time Payment Dashboards",
  "Smart Alerts and Notifications",
  "Seamless Document Linking",
  "WhatsApp Sharing for Payment Documents",
  "Accurate, Efficient, and Manual Payment Recording",
];

export const paymentTargetAudience = [
  "Trading Companies",
  "Manufacturers",
  "Distributors",
  "SMEs looking to digitize their sales process",
];
